<template>
  <div class="page">
    <van-notice-bar v-if="!applyInfo.auditStatus" color="#1989fa" background="#ecf9ff" wrapable :scrollable="false"
                    left-icon="info-o">请仔细填写。若不能确认部分信息可先使用保存功能！
    </van-notice-bar>
    <van-notice-bar wrapable :scrollable="false">
      <ul style="font-size: 12px;">
        <li>附件请上传PDF、JPG、PNG</li>
        <li>如果附件包含多页，请合并为PDF文件后上传</li>
      </ul>
    </van-notice-bar>
    <template v-if="applyInfo.auditStatus==1 || applyInfo.auditStatus==2  || applyInfo.auditStatus==3 ">
      <van-cell-group class="app-card">
        <div class="group-title">审核信息</div>
        <van-field class="readonly" label-align="left" :value="applyInfo.auditStatus | statusFilter" label="审核结果"
                   :readonly="true"/>
        <van-field v-model="applyInfo.auditFeedbackText" :readonly="true" label="审核反馈信息" rows="3" autosize
                   type="textarea"/>
        <van-cell title="审核反馈附件" style="color: #999;" v-if="applyInfo.auditFeedbackPictureUrl">
          <upload v-model="applyInfo.auditFeedbackPictureUrl" :disabled="true"></upload>
        </van-cell>
      </van-cell-group>
    </template>
    <van-cell-group class="app-card">
      <div class="group-title">提交信息</div>
      <van-field class="readonly" label-align="left" v-model="applyInfo.personnelName" label="*姓名"
                 placeholder="未录入" :readonly="true"/>
      <van-field class="readonly" v-model="applyInfo.personnelCard" :readonly="true" label="*身份证号码"/>
      <van-field class="readonly" v-model="applyInfo.companyAccountName" :readonly="true" label="入职单位"
                 placeholder="未录入"/>
      <sys-dict v-model="applyInfo.personnelGender" dict-name='gender' required label="性别" :readonly="!canModify">
      </sys-dict>
      <van-field name="radio" label="申请业务类型" required>
        <template #input>
          <van-radio-group v-model="applyInfo.businessType" :disabled="!canModify">
            <van-radio :name="1">生产</van-radio>
            <van-radio :name="2" style="margin-top: 5px;">流产</van-radio>
            <van-radio :name="3" style="margin-top: 5px;">上环等计生手术</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-cell-group>
        <van-field :readonly="!canModify" v-model="applyInfo.contactInformation" label="联系方式" required
                   placeholder="请输入"/>
        <van-field :readonly="!canModify" v-model="applyInfo.textMessage" label="备注信息" rows="3" autosize
                   type="textarea"/>
      </van-cell-group>
      <van-cell v-if="applyInfo.businessType == 2 || applyInfo.businessType == 3" title="结婚证"
                style="color: #999;">
        <template slot="title">
          <span class="custom-title van-icon van-icon-question" @click="showHelp('请按要求上传文件')">结婚证</span>
        </template>
        <upload :disabled="!canModify" v-model="applyInfo.marryCertificatesUrl" :params="uploadParams"></upload>
      </van-cell>
      <van-cell v-if="applyInfo.businessType == 1 || applyInfo.businessType == 2 || applyInfo.businessType == 3"
                title="诊断证明" style="color: #408CF8;">
        <template slot="title">
          <span class="custom-title van-icon van-icon-question" @click="showHelp('请按要求上传文件')">诊断证明</span>
        </template>
        <upload :disabled="!canModify" v-model="applyInfo.diagnosticCertificateUrl" :params="uploadParams">
        </upload>
      </van-cell>
      <van-cell v-if="applyInfo.businessType == 1" title="出生医学证明" style="color: #408CF8;">
        <template slot="title">
          <span class="custom-title van-icon van-icon-question" @click="showHelp('请按要求上传文件')">出生医学证明</span>
        </template>
        <upload :disabled="!canModify" v-model="applyInfo.birthMedicalCertificateUrl" :params="uploadParams">
        </upload>
      </van-cell>
      <van-cell v-if="applyInfo.businessType == 1" title="生育登记服务单" style="color: #408CF8;">
        <template slot="title">
          <span class="custom-title van-icon van-icon-question" @click="showHelp('请按要求上传文件')">生育登记服务单</span>
        </template>
        <upload :disabled="!canModify" v-model="applyInfo.birthRegistrationUrl" :params="uploadParams"></upload>
      </van-cell>
      <van-cell v-if="applyInfo.businessType == 2 || applyInfo.businessType == 3" title="门诊费用收据"
                style="color: #999;">
        <template slot="title">
          <span class="custom-title van-icon van-icon-question" @click="showHelp('请按要求上传文件')">门诊费用收据</span>
        </template>
        <upload :disabled="!canModify" v-model="applyInfo.outpatientReceiptUrl" :params="uploadParams"></upload>
      </van-cell>
      <!-- 			<van-cell v-if="applyInfo.businessType == 2 || applyInfo.businessType == 3" title="住院费用收据" style="color: #999;">
        <template slot="title">
          <span class="custom-title van-icon van-icon-question" @click="showHelp('请按要求上传文件')">住院费用收据</span>
        </template>
        <upload :disabled="!canModify" v-model="applyInfo.hospitalizationReceiptUrl" :params="uploadParams">
        </upload>
      </van-cell> -->
    </van-cell-group>
    <div style="margin-bottom: 60px;height: 1px;width: 100%;"></div>
    <div v-if="applyInfo.auditStatus!=1 && applyInfo.auditStatus!=2" class="fixed-bottom"
         style="background: #fff;display: flex;flex-direction: row;flex-wrap: nowrap; justify-content: space-around;">
      <van-button style="width: 40%;" plain type="info" round @click="handleClickSave">保存草稿</van-button>
      <van-button style="width: 40%;" type="info" round @click="handleClickSubmit(false)">确认并提交</van-button>
    </div>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>

<script>
import BindPersonnel from '@/components/BindPersonnel'
import SysDict from '@/components/SysDict'
import Upload from '@/components/Upload'
import mixinLoad from '@/mixin/mixin-load.js'
import {
  checkService,
  userInfo as loadUserInfo
} from '@/api/user.js'
import {
  save,
  submit,
  getDetail
} from '@/api/apply-list.js'

export default {
  name: 'ApplyDetail',
  components: {
    SysDict,
    Upload,
    BindPersonnel,
  },
  mixins: [mixinLoad],
  filters: {
    businessTypeFilter: function (value) {
      return ['生产', '流产', '上环等计生手术'][value] || '';
    },
    statusFilter: function (value) {
      return ['草稿', '待审核', '审核通过', '审核不通过'][value] || '';
    }
  },
  computed: {
    canModify() {
      return this.applyInfo && this.applyInfo.auditStatus !== 1 && this.applyInfo.auditStatus !== 2
    }
  },
  data() {
    return {
      editId: null,
      userInfo: {},
      uploadParams: {
        fileType: 'img,file',
        subType: 'png,jpeg,jpg,pdf',
        fileMaxSize: '10240',
        checkFile: '0',
        serverCheck: '1',
        secrecyLevel: '1'
      },
      applyInfo: {
        companyAccountName: null,
        personnelCard: null,
        personnelName: null,
        personnelGender: null,
        marryCertificatesUrl: null,
        diagnosticCertificateUrl: null,
        birthMedicalCertificateUrl: null,
        birthRegistrationUrl: null,
        outpatientReceiptUrl: null,
        hospitalizationReceiptUrl: null,
        contactInformation: null,
        textMessage: null,
        businessType: 1,
        auditStatus: null,
        auditFeedbackPictureUrl: null,
        auditFeedbackText: null
      }
    }
  },
  methods: {
    loadData() {
      const loading = this.showLoading();
      if (this.editId) {
        getDetail(this.editId).then(({
                                       data
                                     }) => {
          this.applyInfo = data;
          loading.clear()
        }).catch((rep) => {
          loading.clear()
        })
      } else {
        loadUserInfo().then((rep) => {
          loading.clear()
          this.userInfo = rep.data;
          this.applyInfo.personnelGender = this.userInfo.gender;
          this.applyInfo.personnelName = this.userInfo.name;
          this.applyInfo.personnelCard = this.userInfo.idCard;
          this.applyInfo.companyAccountName = this.userInfo.companyName;

        }).catch((rep) => {
          loading.clear()
        })
      }
    },
    handleClickSubmit() {
      if (!this.applyInfo.contactInformation) {
        this.$toast('请填写联系方式');
        return;
      }
      this.$dialog.confirm({
        title: '确认并提交',
        message: '是否确认提交资料？',
        confirmButtonText: '确定',
        cancelButtonText: '再想想'
      }).then(() => {
        const loading = this.showLoading();
        submit(this.applyInfo).then((rep) => {
          loading.clear()
          this.showSuccessTip(rep.msg)
          this.$router.go(-1)
        }).catch(() => {
          loading.clear()
        })
      });
    },
    handleClickSave() {
      const loading = this.showLoading();
      save(this.applyInfo).then((rep) => {
        loading.clear()
        this.showSuccessTip(rep.msg)
        this.$router.go(-1)
      }).catch(() => {
        loading.clear()
      })
    },
    showHelp(msg) {
      this.$dialog.alert({
        message: msg
      });
    }
  },
  mounted() {
    this.editId = this.$route.query.id;
    checkService('needResign').then(() => {
      this.loadData();
      this.$dialog.alert({
        title: '提示',
        message: '如填写遇到问题，请先阅读“指南”-“生育保险流程”！',
        confirmButtonText: '好的'
      }).then(() => {
      });
    });
  }
}
</script>

<style>
</style>
